import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import Loader from '../Loader';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TouristAppointmentsApi from '../../../services/TouristAppointmentsApi';
import { MainSelect } from '../../../mainComponent/mainSelect';

export default function TouristAppointment() {
    const [touristList, setTouristList] = useState(null);
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [packages, setPackages] = useState([]);
    const { touristAppointmentsDetails, getPackages } = TouristAppointmentsApi()
    const navigate = useNavigate();
    const pageSize = 10;
    const paginationRef = useRef(currentPage);
    const packageRef = useRef(selectedPackage);

    useEffect(() => {
        getPatientDetails(selectedPackage, currentPage);
        getAllPackages()
    }, []);

    function getPatientDetails(selectedPackage, currentPage) {
        setIsLoading(true);
        const data = {
            page: currentPage,
            pageSize: pageSize,
            selectedPackage: selectedPackage
        }
        touristAppointmentsDetails(data)
            .then((result) => {
                setTouristList(result.data);
                setTotalPages(result.touristListPages)
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getAllPackages = () => {
        getPackages()
            .then((res) => {
                setPackages(res.packageData)
            })
    }

    const handlePageClick = (data) => {
        paginationRef.current = data.selected + 1;
        setCurrentPage(data.selected + 1)
        getPatientDetails(selectedPackage, data.selected + 1);
    }

    const handlePackageChange = (e) => {
        packageRef.current = e.target.value;
        setSelectedPackage(e.target.value);
        getPatientDetails(e.target.value, currentPage)
    };

    const handleViewClick = (e, touristId) => {
        e.preventDefault()
        navigate(`tourist/${touristId}`)
    }

    return (
        <>
            {isLoading === true ?
                <div className='loader-container'>
                    <Loader />
                </div>
                :
                <>
                    <div className="white-box mb-2">
                        <div className='row' align='left'>
                            <div className='mr-4'>
                                <label className='mb-2 font_weight' value="lab">Find Appointments by Package-Name</label>
                                <div className='mt-2'>
                                    <MainSelect value={selectedPackage} onChange={handlePackageChange}>
                                        <option value="">Select Package-Name</option>
                                        {packages && packages.map((item, index) => (
                                            <option key={index} value={item.Package_name} className="form-control">{item.Package_name}</option>
                                        ))}
                                    </MainSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                    {touristList && touristList.length > 0 ?
                        <>
                            <div className='row'>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="font_weight" align="left">Tourist Name</TableCell>
                                                <TableCell className="font_weight" align="left">Tourist Email</TableCell>
                                                <TableCell className="font_weight" align="left">Package Name</TableCell>
                                                <TableCell className="font_weight" align="left">Journey Start Date</TableCell>
                                                <TableCell className="font_weight" align="left">View</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {touristList && touristList.map((item, index) => {
                                                return (
                                                    <TableRow key={item._id}>
                                                        <TableCell align="left">
                                                            {item.touristName}
                                                        </TableCell>

                                                        <TableCell align="left">
                                                            {item.touristEmail}
                                                        </TableCell>

                                                        <TableCell align="left">
                                                            {item.packageName}
                                                        </TableCell>

                                                        <TableCell align="left">
                                                            {moment(item.startDate).format("DD-MM-YYYY")}
                                                        </TableCell>

                                                        <TableCell align="left">
                                                            <Link onClick={(e) => handleViewClick(e, item._id)}>
                                                                <VisibilityIcon style={{ fontSize: 20 }} />
                                                            </Link>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className='mt-4'>
                                <ReactPaginate
                                    breakLabel="..."
                                    nextLabel="Next >"
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={totalPages}
                                    previousLabel="< Previous"
                                    renderOnZeroPageCount={null}
                                    marginPagesDisplayed={2}
                                    containerClassName="pagination"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    activeClassName="active"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    forcePage={currentPage - 1}
                                />
                            </div>
                        </> :
                        <div className="clinicHistory font_weight" >Appointments are not Available</div>
                    }

                </>
            }
        </>
    )
}